import { createFileRoute } from '@tanstack/react-router';
import ResearchListPage from '@/pages/ResearchListPage.jsx';

export const Route = createFileRoute('/research-profiles/')({ component: ResearchListPage });
